import { render, staticRenderFns } from "./user-company.vue?vue&type=template&id=7fd7c656&scoped=true"
import script from "./user-company.vue?vue&type=script&lang=js"
export * from "./user-company.vue?vue&type=script&lang=js"
import style0 from "./user-company.vue?vue&type=style&index=0&id=7fd7c656&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd7c656",
  null
  
)

export default component.exports